import axios from 'axios';

const getCurrencyApiUrl = () => {
    return `${process.env.REACT_APP_API_URL_DE}/api/currency`;
};

export const getExchangeRate = async () => {
    const response = await axios.get(
        getCurrencyApiUrl(),
        {
            params: {
                fromCurrency: 'USD',
                toCurrency: 'MXN',
                conversionType: 'Corporate'
            },
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        }
    );

    return response.data;
};